export default process.env.VUE_APP_ENV;